import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {
  ProcessFlowchartEndNode,
  ProcessFlowchartOutputNode,
  ProcessFlowchartRootNode,
  ProcessFlowchartRouterNode,
  ProcessFlowchartTaskNode,
} from '../ProcessFlowchartNodeDetailType';
import {ProcessFlowchartInteractiveNode} from '../ProcessFlowchartVizConstants';

export function isTaskNode(node: ProcessFlowchartInteractiveNode): node is ProcessFlowchartTaskNode {
  return node.type === ProcessFlowchartNodeDetailsType.TASK_NODE_DETAILS;
}

export function isRouterNode(node: ProcessFlowchartInteractiveNode): node is ProcessFlowchartRouterNode {
  return node.type === ProcessFlowchartNodeDetailsType.ROUTER_NODE_DETAILS;
}

export function isOutputNode(node: ProcessFlowchartInteractiveNode): node is ProcessFlowchartOutputNode {
  return node.type === ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS;
}

export function isRootNode(node: ProcessFlowchartInteractiveNode): node is ProcessFlowchartRootNode {
  return node.type === ProcessFlowchartNodeDetailsType.ROOT_NODE_DETAILS;
}

export function isEndNode(node: ProcessFlowchartInteractiveNode): node is ProcessFlowchartEndNode {
  return node.type === ProcessFlowchartNodeDetailsType.END_NODE_DETAILS;
}
